import { KeycloakInstance } from 'keycloak-js';

export namespace KeyCloak {
  export enum TokenPrefix {
    USER_TYPE = 'user_type',
  }

  export enum KeyCloakClients {
    AS_FRONTEND = 'as-frontend',
  }

  export enum UserTypes {
    INTERNAL = 'internal_user',
    EXTERNAL = 'external_user',
  }

  export enum KeyCloakOnLoad {
    LOGIN_REQUIRED = 'login-required',
  }
  export type User = UserTypes.INTERNAL | UserTypes.EXTERNAL;
  export type KeycloakPlugin = KeycloakInstance;
}
